export default __webpack_public_path__ + "static/media/flash.c1c36b83.png";